import { useIntl } from 'react-intl';
import Dialog from '@alltrails/denali/components/Dialog';

type DeleteDialogProps = {
  type: 'waypoint' | 'segment';
  onDeleteClick: () => void;
  setIsOpen: (isOpen: boolean) => void;
  isDeleteLoading?: boolean;
};

const DeleteDialog = ({ type, onDeleteClick, setIsOpen, isDeleteLoading }: DeleteDialogProps) => {
  const intl = useIntl();
  return (
    <Dialog
      title={
        type === 'waypoint' ? intl.formatMessage({ defaultMessage: 'Delete waypoint?' }) : intl.formatMessage({ defaultMessage: 'Delete segment?' })
      }
      body={
        type === 'waypoint'
          ? intl.formatMessage({ defaultMessage: 'This waypoint will be deleted from your route' })
          : intl.formatMessage({ defaultMessage: 'This segment will be deleted from your route' })
      }
      buttons={{
        primary: {
          onClick: onDeleteClick,
          text: intl.formatMessage({ defaultMessage: 'Delete' }),
          loading: isDeleteLoading
        },
        flat: {
          onClick: () => setIsOpen(false),
          text: intl.formatMessage({ defaultMessage: 'Keep' })
        }
      }}
      onRequestClose={() => setIsOpen(false)}
      size="sm"
    />
  );
};

export default DeleteDialog;
